interface Role {
    key: string;
    value: string;
    canEdit: boolean;
    nameKey: string;
    descKey?: string;
}
const roleLimited: Array<string> = [
    'createUsergroup',
    'editUsergroup',
    'copyUsergroup',
    'engageWithUsergroup',
    'deleteUsergroup',
    'saveUsergroup',
    'saveNewUsergroup',
    'createCampaign',
    'createGoal',
    'crossDomain'
];

const roles: Array<Role> = [
    {
        key: 'owner',
        value: '0',
        canEdit: true,
        nameKey: 'member.role_owner'
    },
    {
        key: 'admin',
        value: '2',
        canEdit: true,
        nameKey: 'member.role_admin',
        descKey: 'member.role_admin_desc'
    },
    {
        key: 'readonly',
        canEdit: false,
        value: '1',
        nameKey: 'member.role_readonly',
        descKey: 'member.role_readonly_desc'
    }
];

export default {
    roles,
    roleLimited
};
